"use client"

import { useMemo } from "react"
import { twMerge } from "tailwind-merge"

import { generateResponsiveCSS } from "@/(admin)/modules/ui-builder/config/lib/helper"
import { PromotionShowcaseContent } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/PromotionShowcase/components/PromotionShowcaseContent"
import type { PromotionShowcaseProps } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/PromotionShowcase/types/config"

export const RenderConfig = {
  render: ({
    sectionTitle,
    logo,
    promotions,
    slidesPerView,
    spaceBetween,
    className,
    styles,
    responsiveType,
    id: componentId,
  }: PromotionShowcaseProps & { id?: string }) => {
    const id = useMemo(
      () => componentId || `promotion-showcase-${Math.random().toString(36).substr(2, 9)}`,
      [componentId]
    )
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)

    return (
      <>
        {responsiveCSS}
        <div className={twMerge(className)} id={id}>
          <PromotionShowcaseContent
            id={id}
            sectionTitle={sectionTitle}
            logo={logo}
            promotions={promotions}
            slidesPerView={slidesPerView}
            spaceBetween={spaceBetween}
            className=""
          />
        </div>
      </>
    )
  },
}

